module.exports = __webpack_public_path__ + "static/img/xs1-4.d0491bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xs1-4.png
// module id = 797
// module chunks = 0